import React from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import TeamManager from './TeamManager';
import amplifyconfig from './amplifyconfiguration.json';

Amplify.configure(amplifyconfig);

function App() {
  return (
    <Authenticator>
      {({ signOut, user }) => (
        <TeamManager user={user} signOut={signOut} />
      )}
    </Authenticator>
  );
}

export default App;